import {SimpleCallback} from "../types/SimpleCallback";

const mergeCallbacks = (...callbacks: SimpleCallback[]) : SimpleCallback => {
    return () => {
        callbacks.forEach(callback => callback());
    };
}

export default mergeCallbacks;
